import React from 'react'

const TeamDivTable = ({
  rank,
  logoTeam,
  name,
  mp,
  w,
  d,
  l,
  gf,
  ga,
  points,
  last5,
}) => {
  return (
    <div className='flex bg-gray-300 mb-1 rounded-sm md:p-2  md:w-5/6 md:mx-auto'>
      <div className=' w-3/6 md:w-2/5 md:w-2/5 flex  items-center mx-2 md:mx-4'>
        <div className='w-1/7 flex justify-start text-xs lg:text-lg '>
          {rank}
        </div>
        <div className='w-1/7'>
          <img className='h-[30px]  md:h-[50px] mx-2 md:mx-4' src={logoTeam} />
        </div>

        <div className='text-xs lg:text-lg'>
          <div>{name}</div>
        </div>
      </div>

      <div className=' w-3/6 md:w-3/5 flex  justify-between'>
        <div className=' w-1/8 md:w-1/12'>
          <div>
            <h1 className='text-xs lg:text-sm text-white mb-1 md:mb-2'>MP</h1>
          </div>
          <div className='text-sm lg:text-lg'>{mp}</div>
        </div>

        <div className='  w-1/8 md:w-1/12'>
          <div>
            <h1 className='text-xs lg:text-sm text-white mb-1 md:mb-2'>W</h1>
          </div>
          <div className='text-sm lg:text-lg'>{w}</div>
        </div>

        <div className=' w-1/8 md:w-1/12'>
          <div>
            <h1 className='text-xs lg:text-sm text-white mb-1 md:mb-2'>D</h1>
          </div>
          <div className='text-sm lg:text-lg'>{d}</div>
        </div>

        <div className=' w-1/8 md:w-1/12'>
          <div>
            <h1 className='text-xs lg:text-sm text-white mb-1 md:mb-2'>L</h1>
          </div>
          <div className='text-sm lg:text-lg'>{l}</div>
        </div>

        <div className=' w-1/8 md:w-1/12'>
          <div>
            <h1 className='text-xs lg:text-sm text-white mb-1 md:mb-2'>GF</h1>
          </div>
          <div className='text-sm lg:text-lg'>{gf}</div>
        </div>

        <div className=' w-1/8 md:w-1/12'>
          <div>
            <h1 className='text-xs lg:text-sm text-white mb-1 md:mb-2'>GA</h1>
          </div>
          <div className='text-sm lg:text-lg'>{ga}</div>
        </div>

        <div className='  w-1/8 md:w-1/12 '>
          <div>
            <h1 className='text-xs lg:text-sm text-white mb-1 md:mb-2'>PTS</h1>
          </div>
          <div className='text-sm lg:text-lg'>{points}</div>
        </div>

        <div className='w-4/12 hidden md:flex flex-col mx-1 '>
          <div>
            <h1 className='text-xs lg:text-sm text-white  mb-1 md:mb-2'>
              LAST 5
            </h1>
          </div>
          <div className='text-sm lg:text-lg flex '>{last5}</div>
        </div>
      </div>
    </div>
  )
}

export default TeamDivTable
